import {
    ADDED,
    DELETED,
    FETCHED_ALL,
    FILTERED,
    LOADED_FORM_DATA,
    UPDATED,
} from "./actionTypes";

export const fetchedAll = (books) => {
    return {
        type: FETCHED_ALL,
        payload: books,
    };
};

export const added = (book) => {
    return {
        type: ADDED,
        payload: book,
    };
};

export const updated = (bookId, data) => {
    return {
        type: UPDATED,
        payload: {
            bookId, data
        }
    };
};

export const loadedFormData = (data) => {
    return {
        type: LOADED_FORM_DATA,
        payload: data
    };
};

export const deleted = (bookId) => {
    return {
        type: DELETED,
        payload: bookId,
    };
};

export const filtered = (featureData) => {
    return {
        type: FILTERED,
        payload: featureData,
    };
};

